import styled from 'styled-components'

export const NetworkingContainer = styled.ul`
margin-bottom:0rem;
.img{
    width: 23px;
    height: 23px;
}

`;